import decodeJwtToken from 'civic-champs-shared/auth/utils/decodeJwtToken'
import { noticeError, recordPageAction } from 'newrelic/newrelic-telemetry'

// Every legitimate screen renders either text or a progress spinner, so an empty page
// this long after a load or navigation is the "white screen" users report.
const BLANK_AFTER_MS = 20000
const COGNITO_KEY_PREFIX = 'CognitoIdentityServiceProvider.'

let timer = null
let reported = false

// Content is measured on document.body, not #root: the kiosk and every other
// full-screen MUI dialog render through a portal outside #root, so a working kiosk
// screen looks blank from #root alone.
const isBlank = () => {
  const root = document.getElementById('root')
  return !!root && !document.body.innerText.trim() && !document.body.querySelector('[role="progressbar"]')
}

const readStoredSession = () => {
  const snapshot = {}

  try {
    const keys = Object.keys(localStorage).filter(key => key.startsWith(COGNITO_KEY_PREFIX))
    const idTokenKey = keys.find(key => key.endsWith('.idToken'))

    snapshot.hasCognitoUser = keys.some(key => key.endsWith('.LastAuthUser'))
    snapshot.hasIdToken = !!idTokenKey
    snapshot.hasRefreshToken = keys.some(key => key.endsWith('.refreshToken'))
    snapshot.hasAppToken = !!localStorage.getItem('token')

    if (idTokenKey) {
      const { exp } = decodeJwtToken(localStorage.getItem(idTokenKey))
      snapshot.idTokenExpiredSec = Math.round(Date.now() / 1000 - exp)
    }
  } catch (error) {
    // A partial snapshot is still worth reporting.
  }

  return snapshot
}

const check = getState => {
  if (reported || !isBlank()) return
  reported = true

  const { auth = {}, features = {}, kiosk = {} } = getState() || {}
  const attributes = {
    path: window.location.pathname,
    ...readStoredSession(),
    authInitialized: !!auth.initialized,
    authBootstrapFailed: !!auth.bootstrapFailed,
    featuresInitialized: !!features.initialized,
    kioskStatus: String(kiosk.status),
    msSinceLoad: Math.round(performance.now()),
  }

  recordPageAction('admin_blank_screen', attributes)
  noticeError(new Error('admin_blank_screen'), attributes)
}

export const startAppHealthMonitor = (getState, history) => {
  const schedule = () => {
    if (reported) return
    window.clearTimeout(timer)
    timer = window.setTimeout(() => check(getState), BLANK_AFTER_MS)
  }

  schedule()
  history.listen(schedule)
}
